import React from 'react';

import DefaultLayout from '../layouts/DefaultLayout';
import HomeHero from '../components/ui/HomeHero.js';
import ClientLogos from '../components/ui/ClientLogos.js';
import Planet from '../components/ui/Planet.js';

const HomePage = () => (
  <DefaultLayout>
    <HomeHero />
    <ClientLogos />
    <Planet />
  </DefaultLayout>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/HomePage.js